// src/components/Collapsible.js
import React, { useState } from 'react';
import styled from 'styled-components';

// Styled components for the collapsible section
const CollapsibleContainer = styled.div`
    padding-top: 10px;
`;

const CollapsibleHeader = styled.h3`
    cursor: pointer;
    font-size: 1.25rem;
    font-weight: 600;
    color: #000; /* Muted dark blue for professionalism */
    margin-bottom: 10px;
    margin-left: 15px;
    &:hover {
        color: #2f4858; /* Darker blue on hover for clarity */
    }
`;

// const CollapsibleContent = styled.div`
//     max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0')};
//     overflow: hidden;
//     transition: max-height 0.3s ease;
//     padding-left: 15px; /* Add some padding for content */
//     color: #000; /* Soft dark grey for the text */
//     line-height: 1.75; /* Better readability */
// `;

const CollapsibleContent = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isOpen'
})`
    max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0')};
    overflow: hidden;
    transition: max-height 0.3s ease;
    padding-left: 15px;
    color: #000;
    line-height: 1.75;
  `;

const CollapsibleIcon = styled.span`
    margin-left: 10px;
    font-size: 0.9rem;
    color: #000; /* Match the heading color */
`;

const Collapsible = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <CollapsibleContainer>
            <CollapsibleHeader onClick={() => setIsOpen(!isOpen)}>
                {title} <CollapsibleIcon>{isOpen ? '▲' : '▼'}</CollapsibleIcon>
            </CollapsibleHeader>
            <CollapsibleContent isOpen={isOpen}>
                {children}
            </CollapsibleContent>
        </CollapsibleContainer>
    );
};

export default Collapsible;
